<div *ngIf="activeServiceVersion">
  <app-page-loader *ngIf="dataLoading"></app-page-loader>
  <ng-container *ngIf="ChangeState.REJECTED === changeTask?.changeState; else showUpdateTemplate">
    <div class="flex justify-center max-width-lg update-not-in-use">
      <div class="flex flex-row justify-center items-center pl-20">
        <mat-icon class="mr-10" svgIcon="info"></mat-icon>
        <span class="fw-600">{{'AUTO_UPDATE.LATEST_UPDATE_NOT_IN_USE' | transloco}}</span>
      </div>
    </div>
  </ng-container>
  <ng-template #showUpdateTemplate>
    <div class="max-width-lg auto-update">
      <div class="flex flex-row justify-between flex-auto">
        <section class="flex flex-col justify-between">
          <div class="flex-col">
            <div class="mat-headline-4 mb-8">
              {{'AUTO_UPDATE.STATUS.' + (isUpdateAvailable ? 'AVAILABLE' : 'COMING_SOON') | transloco}}</div>
            <ng-container *ngIf="isUpdateAvailable; else showComingSoonSubtitle">
              <span>{{serviceVersionsInfo.updateVersion.version}}</span>
            </ng-container>
            <ng-template #showComingSoonSubtitle>
              <span>{{service.name}}</span>
            </ng-template>
          </div>
          <button *ngIf="isUpdateAvailable" class="flex flex-row justify-between items-center accent h-48" [matMenuTriggerFor]="viewTestResult">
              <span class="mr-10">{{'AUTO_UPDATE.TEST_REPORTS' | transloco}}</span>
              <span class="vertical-line h-48"></span>
              <mat-icon svgIcon="expand_more" class="icon-md mt-4"></mat-icon>
          </button>
          <mat-menu #viewTestResult="matMenu" class="mt-6">
            <button mat-menu-item>
              <div class="flex flex-row">
                <mat-icon svgIcon="file_download" class="icon-md mt-12 mr-10"></mat-icon>
                <span class="mr-10">{{'AUTO_UPDATE.DOWNLOAD' | transloco}}</span>
              </div>
            </button>
            <button mat-menu-item>
              <div class="flex flex-row">
                <mat-icon svgIcon="visibility" class="icon-md mt-12 mr-10"></mat-icon>
                <span class="mr-10">{{'AUTO_UPDATE.VIEW_TEST_RESULTS' | transloco}}</span>
              </div>
            </button>
          </mat-menu>
        </section>

        <section class="flex flex-col justify-between">
          <div class="flex flex-col">
            <div class="mat-headline-6 mb-8">{{'AUTO_UPDATE.WHATS_NEW' | transloco}}</div>
            <div>{{activeServiceVersion.description}}</div>
          </div>
          <a class="link" [href]="activeServiceVersion.releaseNotes"
             target="_blank">{{'AUTO_UPDATE.LEARN_MORE' | transloco}}</a>
        </section>

        <section class="flex flex-col">
          <div *ngIf="isUpdateAvailable" class="flex flex-col flex-auto">

            <ng-container *ngIf="ChangeState.APPLYING === changeTask?.changeState; else updateNotApplied">
              <div class="flex flex-col">
                <div class="flex flex-row mb-4 mt-32">
                  <mat-icon svgIcon="schedule" class="icon-sm applying mr-12"></mat-icon>
                  <span class="color-accent-2">{{'AUTO_UPDATE.UPDATE_IN_PROGRESS' | transloco}}</span>
                </div>
                <div class="color-accent-2">{{'AUTO_UPDATE.UPDATE_CANNOT_BE_CANCELLED_ANYMORE' | transloco}}</div>
              </div>
            </ng-container>
            <ng-template #updateNotApplied>
              <div class="flex flex-col">
                <div class="mat-headline-6 mr-10 mb-8">{{'AUTO_UPDATE.SCHEDULED_UPDATE_DATE' | transloco}}</div>
                <div class="mb-16">{{changeTask?.maintenanceWindowStart | date: 'dd MMM yyyy'}}</div>
                <div class="mb-8" [ngClass]="{'color-accent-2': !deferralCount}">{{defferLabel}}</div>
                <button *ngIf="deferralCount > 0" (click)="openDeferUpdateDialog()"
                        class="btn-link fw-400">{{'AUTO_UPDATE.SKIP_UPDATE' | transloco}}</button>
              </div>
              <span class="flex-auto"></span>
              <div *ngIf="deferralCount === 0">
                <div class="mb-8">{{'AUTO_UPDATE.IF_YOU_ARE_UNABLE_TO_UPDATE' | transloco}}</div>
                <button class="btn-link fw-400"
                        (click)="openContactUsForm()">{{'AUTO_UPDATE.CONTACT_SUPPORT' | transloco}}</button>
              </div>
            </ng-template>
          </div>
        </section>
      </div>
    </div>
  </ng-template>
</div>
